import { AllCompanyReviewSummaryData } from "../Model/companyReviewsObjects";
import { ALL_COMPANY_REVIEW_SUMMARY } from "../Reducers/allCompanyReviewSummaryReducer";
import { fetchAllCompanyReviewSummary } from "../Util/queries";

export const getAllCompanyReviewSummary = (startDate = null, endDate = null, timeframe = "LAST_30_DAYS") => async (dispatch) => {
    try {
        const response = await fetchAllCompanyReviewSummary(startDate, endDate, timeframe);
        dispatch({
            type: ALL_COMPANY_REVIEW_SUMMARY,
            payload: new AllCompanyReviewSummaryData(response.data, timeframe, startDate, endDate)
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: ALL_COMPANY_REVIEW_SUMMARY,
            payload: new AllCompanyReviewSummaryData({success: false}, timeframe, startDate, endDate)
        });  
    }
}
